import { combineReducers } from 'redux';
import { visuallyImpairedSettings } from './visuallyImpaired';
import { currentDivisionSlice } from './currentDivision';

export const app = combineReducers({
    visuallyImpairedSettings: visuallyImpairedSettings.reducer,
    currentDivision: currentDivisionSlice.reducer
});
